/**
 * @description parse html
 * @author wangfupeng
 */

import { SlateDescendant, SlateText } from "@wangeditor/editor";
import type { IDomEditor } from "@wangeditor/core";
import { ParagraphElement } from "./custom-types";
import type { DOMElement } from "@wangeditor/core/dist/core/src/utils/dom";

function parseParagraphHtml(
  elem: DOMElement,
  children: SlateDescendant[],
  editor: IDomEditor
): ParagraphElement {
  children = children.filter((child) => {
    if (SlateText.isText(child)) return true;
    if (editor.isInline(child)) return true;
    return false;
  });

  // 无 children ，则用纯文本
  if (children.length === 0) {
    children = [{ text: elem.innerHTML.replace(/\s+/gm, " ") }];
  }

  return {
    type: "paragraph",
    // @ts-ignore
    children
  };
}

export default {
  selector: "p:not([data-w-e-type])", // data-w-e-type 属性，留给自定义元素，保证扩展性
  parseElemHtml: parseParagraphHtml
};
